import { containerTransportOrder } from "./containerTransportOrder";
import { containerTransportGrid } from "./containerTransportGrid";

const base = {
	projectTitle: "MOVE Portal",
	navigation_NewOrder: "New Order",
	...containerTransportOrder,
	...containerTransportGrid
};

export { base };

